const FittingLab = {
    fittingLab: () => "store/fitting-lab",
    orderReady: () => "store/fitting-lab/orders/history",
    updateOrderStatus: (id:string) => `store/fitting-lab/order/${id}`,
    generatePdf: (orderId:string) => `store/order/${orderId}/download-receipt`,
    viewOrderDetails: (id: string) => `store/order/${id}`,
    orderForm:(id:string)=>`store/fitting-lab/order-form/${id}`
}

export default FittingLab